/**
 * Personuppgiftsavtal — the standalone variant of the personuppgiftsbilaga.
 *
 * Same approved GDPR artikel 13 text (sections 1–9 shared verbatim), but its
 * own contract in "Övriga avtal", signed by hyresvärd and hyresgäst via
 * Scrive. Requires the personuppgiftsbilaga blocks in the registry.
 */
import { COMPOSITION_SCHEMA, COMPOSITION_VERSION } from '@hyranai/regta-document-ir';
import { signingPartiesFor } from '../common/index.js';
import { PERSONUPPGIFT_PREAMBLE, letterheadAndFooter, personuppgiftSharedBody, } from './personuppgiftsbilaga.js';
const TITLE = 'Personuppgiftsavtal · Version 2026';
const FORM_NUMBER = 'Formulär R-17';
const PARTY_SLOTS = [
    { id: 'lessor', label: 'Hyresvärd', role: 'lessor', ordinal: 0, required: true, signs: true },
    { id: 'lessee', label: 'Hyresgäst', role: 'lessee', ordinal: 0, required: true, signs: true },
];
const META = {
    category: 'Övriga avtal',
    shortTitle: 'Personuppgiftsavtal',
    formNumber: FORM_NUMBER,
    preamble: PERSONUPPGIFT_PREAMBLE,
    description: 'GDPR-information (artikel 13) om hur hyresvärden behandlar hyresgästens ' +
        'personuppgifter — som fristående, signerat dokument.\n\n' +
        'Vem undertecknar: hyresvärden och hyresgästen. Leverans: skickas via ' +
        'Scrive.\n\n' +
        'Ska informationen i stället bifogas ett hyresavtal och signeras ' +
        'tillsammans med det — använd bilagan "Personuppgiftsbilaga" från ' +
        'avtalets Bilagor-flik i stället.',
    statute: 'Europaparlamentets och rådets förordning (EU) 2016/679 (GDPR), artikel 13',
    signingMode: 'digital',
    signingPlacementAnchors: 'per-party-label',
    numberStyle: 'paragraph',
    partySlots: PARTY_SLOTS,
};
export const personuppgiftsavtalV1 = (values = {}) => ({
    schema: COMPOSITION_SCHEMA,
    version: COMPOSITION_VERSION,
    documentKey: 'personuppgiftsavtal',
    documentVersion: 'v1',
    title: TITLE,
    locale: 'sv-SE',
    meta: META,
    values,
    blocks: [
        ...letterheadAndFooter(TITLE, FORM_NUMBER),
        ...personuppgiftSharedBody('personuppgiftsavtal.personuppgiftsansvarig@v1'),
        {
            instanceId: 'bekraftelse',
            blockRef: 'personuppgiftsavtal.bekraftelse@v1',
            input: { statement: true, parties: signingPartiesFor(PARTY_SLOTS) },
        },
    ],
});
//# sourceMappingURL=personuppgiftsavtal.js.map